import script from "./staLoc.vue?vue&type=script&setup=true&lang=js"
export * from "./staLoc.vue?vue&type=script&setup=true&lang=js"

import "./staLoc.vue?vue&type=style&index=0&id=252b2a3b&lang=css"

const __exports__ = script;

export default __exports__